const USERS_COLLECTION = "users";

const processDoc = (doc) => {
  return { id: doc.id, ...doc.data() };
};

function UsersMixin(firebase) {
  return {
    async findUserById(id) {
      const snapshot = await this.collection(USERS_COLLECTION).doc(id).get();
      if (!snapshot.exists) {
        return null;
      }

      return processDoc(snapshot);
    },

    async updateUserById(id, data) {
      return this.collection(USERS_COLLECTION).doc(id).set(data, { merge: true });
    },
    async incrementNrOfComments(userId) {
      //ss
      const increment = firebase.firestore.FieldValue.increment(1);

      const dataToStore = {
        nrOfComments: increment,
        lastCommentDate: new Date().toISOString()
      };

      return this.collection(USERS_COLLECTION).doc(userId).set(dataToStore, { merge: true });
    },

    async getUsersFromOrganization(id) {
      const snapshot = await this.collection(USERS_COLLECTION)
        .where(`orgas.${id}`, "!=", null)
        .get();
      return snapshot.docs.map(processDoc);
    }
  };
}

module.exports = UsersMixin;
